import SiteLayout from "@/components/feature/SiteLayout";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import SearchBanner from "@/pages/home/components/SearchBanner";
import CategoryLinks from "@/pages/home/components/CategoryLinks";
import MovieRow from "@/pages/home/components/MovieRow";
import { getLatestMovies, getPopularMovies } from "@/utils/movie";

export default function Home() {
  const latest = getLatestMovies(20);
  const popular = getPopularMovies(8);

  return (
    <SiteLayout>
      <HeroCarousel />
      <SearchBanner />
      <CategoryLinks />
      <MovieRow
        title="最新影片"
        subtitle="按上映年份更新的最新三级影片资源"
        movies={latest}
        moreLink="/category/urban"
        moreLabel="进入分类浏览"
      />
      <MovieRow
        title="热门推荐"
        subtitle="近期播放量与收藏数最高的人气影片"
        movies={popular}
        columns="four"
        moreLink="/search"
        moreLabel="前往搜索"
      />
      <div className="h-12 md:h-16" />
    </SiteLayout>
  );
}